import FailedAttemptReporter from "../../forms/validator/book/failedAttemptReporter";

export default class BookingFormAttemptFailedListener
{
    constructor()
    {
        this.eventDelegation();
    }

    eventDelegation()
    {
        $(window).observe('failedAttemptEvent', function (event, form) {
            const failedAttemptReporter = new FailedAttemptReporter(form);
            failedAttemptReporter.report();
        });

    }
}
